const categoryKeys = [
  '现代简约',
  '原木风',
  '北欧风',
  '法式',
  '美式',
  '中古风',
];

function buildCategoryEn() {
  const m = {
    现代简约: 'Modern Minimalist',
    原木风: 'Natural Wood',
    北欧风: 'Scandinavian',
    法式: 'French',
    美式: 'American',
    中古风: 'Mid-Century',
  };
  return m;
}

function buildCategoryZh() {
  return Object.fromEntries(categoryKeys.map((k) => [k, k]));
}

export const messages = {
  en: {
    appTitle: 'Furniture Store',
    layout: {
      welcome: 'Welcome, {name}',
      loginRegister: 'Sign in / Register',
      profile: 'Profile',
      logout: 'Log out',
    },
    lang: {
      en: 'English',
      zh: '中文',
      label: 'Language',
    },
    login: {
      tabLogin: 'Sign in',
      tabRegister: 'Register',
      email: 'Email',
      emailRequired: 'Please enter your email',
      emailInvalid: 'Invalid email format',
      password: 'Password',
      passwordRequired: 'Please enter your password',
      passwordMin: 'At least 6 characters',
      nickname: 'Display name',
      nameRequired: 'Please enter a display name',
      nameMin: 'At least 2 characters',
      code: 'Verification code',
      codeRequired: 'Please enter the code',
      codeLen: '6 characters (letters and digits)',
      refreshCode: 'Refresh',
      confirmPassword: 'Confirm password',
      confirmRequired: 'Please confirm your password',
      passwordMismatch: 'Passwords do not match',
      signIn: 'Sign in',
      signUp: 'Create account',
    },
    toast: {
      loginSuccess: 'Signed in successfully',
      registerSuccess: 'Account created',
      codeMismatch: 'Verification code is incorrect',
      updateSuccess: 'Profile updated',
    },
    home: {
      loading: 'Loading…',
      sectionTitle: 'Curated furniture',
      all: 'All',
      empty: 'No products',
      noImage: 'No image',
    },
    category: buildCategoryEn(),
    product: {
      backHome: 'Back to home',
      loading: 'Loading…',
      loadError: 'Failed to load product',
      specs: 'Specifications',
      choosePayment: 'Payment method',
      payNow: 'Pay now',
      alipayTitle: 'Alipay',
      wechatTitle: 'WeChat Pay',
      amount: 'Amount:',
      scanTip: 'Scan the QR code with {method} to pay',
      orderNo: 'Order no.:',
      loginToPay: 'Please sign in to pay',
      qrAlt: 'Payment QR code',
    },
    payment: {
      alipay: 'Alipay',
      wechat: 'WeChat Pay',
    },
    profile: {
      title: 'Profile',
      backHome: 'Back to home',
      username: 'Username',
      nickname: 'Display name',
      nameRequired: 'Please enter a display name',
      namePlaceholder: 'Display name',
      newPassword: 'New password',
      passwordMin: 'At least 6 characters',
      passwordPlaceholderLeaveBlank: 'Leave blank to keep current password',
      confirmPassword: 'Confirm password',
      confirmPlaceholder: 'Re-enter new password',
      save: 'Save changes',
    },
    footer: {
      title: 'Operator',
      companyName: 'FLASH AGENCY LIMITED',
      address:
        'RM 1002, 10/F, EASEY COMM BUILDING\n253-261 HENNESSY ROAD\nWAN CHAI\nHONG KONG',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      aboutUs: 'About Us',
      refundPolicy: 'Refund Policy',
      privacyPolicy: 'Privacy Policy',
      termsAndConditions: 'Terms & Conditions',
    },
    legal: {
      contact: {
        title: 'Contact Information',
      },
      about: {
        title: 'About Us',
        subtitle: 'A one-stop online platform for furniture and chairs',
        positionTitle: 'Who We Are',
        positionText:
          'We are an e-commerce platform focused on furniture, dining chairs, office chairs, lounge chairs, and related home products, committed to practical and stylish furnishing solutions.',
        offerTitle: 'What We Offer',
        offerItem1: 'Curated furniture and chair products across multiple design styles.',
        offerItem2: 'Clear product specs, material details, dimensions, and product images.',
        offerItem3: 'A secure ordering process with stable after-sales support.',
        visionTitle: 'Our Service Philosophy',
        visionText:
          'We value every shopping journey and uphold transparency, integrity, and timely communication to help you find suitable furniture and chairs with confidence.',
        qualityTitle: 'Quality and Product Standards',
        qualityItem1:
          'Most chair and furniture products undergo appearance and structural checks before shipment.',
        qualityItem2:
          'Material descriptions are provided for reference, including wood, fabric, leather, and metal details when available.',
        qualityItem3:
          'For batch-produced items, slight color and texture variation may exist within a reasonable range.',
        deliveryTitle: 'Delivery and Customer Support',
        deliveryText:
          'We provide order tracking support and after-sales consultation. If you encounter logistics delays, damaged packages, or missing parts, please contact us promptly so we can coordinate a solution.',
      },
      refund: {
        title: 'Refund Policy',
        subtitle: 'Applicable to furniture and chair orders on this platform',
        timelineTitle: 'Refund Request Timeline',
        timelineText:
          'Please contact us as soon as possible for a refund request. Unshipped orders are prioritized for cancellation and refund; shipped orders are reviewed based on logistics and delivery status.',
        availableTitle: 'Refundable Cases',
        availableItem1: 'Failure to ship due to platform-side reasons or overdue fulfillment.',
        availableItem2: 'Verified product quality issues.',
        availableItem3: 'The received item is significantly inconsistent with the order description.',
        unavailableTitle: 'Non-Refundable Cases',
        unavailableItem1: 'Subjective preference changes after normal signed delivery and usage.',
        unavailableItem2: 'Damage caused by improper use, installation, or storage.',
        unavailableItem3:
          'Requests beyond after-sales timeline or without valid order proof.',
        arrivalTitle: 'Refund Arrival',
        arrivalText:
          'After approval, the refund will be returned to the original payment account. Arrival time depends on payment channels and banks, usually within 3-10 business days.',
        processTitle: 'Refund Processing Steps',
        processItem1:
          'Submit your request with order number, issue description, and supporting photos/videos.',
        processItem2:
          'Our support team reviews the case and may contact you for additional details.',
        processItem3:
          'After approval, the system initiates the refund and notifies you of processing status.',
        shippingTitle: 'Return Shipping and Fees',
        shippingText:
          'If the return is caused by product quality issues or seller fault, return shipping may be covered by us according to review results. For non-quality returns, shipping and related handling fees may be borne by the buyer.',
      },
      privacy: {
        title: 'Privacy Policy',
        subtitle: 'How we collect, use, and protect your information',
        collectTitle: 'What We Collect',
        collectText:
          'When you register, place orders, contact support, or use site functions, we may collect necessary information including account details, order data, shipping details, and device access logs.',
        usageTitle: 'How We Use Information',
        usageItem1: 'To process furniture and chair orders, shipping, and after-sales service.',
        usageItem2: 'To support account security checks, risk control, and operations optimization.',
        usageItem3:
          'To provide service notices and customer support within your authorized scope.',
        protectTitle: 'How We Protect Information',
        protectText:
          'We adopt reasonable technical and managerial measures to prevent unauthorized access, disclosure, tampering, or loss. Data access is limited to required roles only.',
        rightsTitle: 'Your Rights',
        rightsText:
          'You may request to view, correct, or delete your personal information, and you may also request account deletion. We will handle your request in accordance with applicable laws.',
        cookiesTitle: 'Cookies and Similar Technologies',
        cookiesText:
          'We may use cookies or similar technologies to remember your preferences, keep sessions stable, and improve website performance. You can manage cookie settings in your browser.',
        thirdPartyTitle: 'Third-Party Services',
        thirdPartyItem1:
          'Some payment, logistics, analytics, or communication services may be provided by third parties.',
        thirdPartyItem2:
          'We require partners to process data within legitimate and necessary scopes.',
        thirdPartyItem3:
          'Please also review privacy terms of relevant third-party service providers when applicable.',
      },
      terms: {
        title: 'Terms and Conditions',
        subtitle: 'Please read these terms before using the platform',
        serviceTitle: 'Service Description',
        serviceText:
          'This platform provides product display and online purchase services for furniture and chairs. By using our services, you agree to these terms and related policies.',
        accountTitle: 'Account and Order',
        accountItem1:
          'Users should ensure registration information is true, complete, and up to date.',
        accountItem2:
          'Before submitting orders, please verify model, quantity, price, and shipping address.',
        accountItem3:
          'Any delay or loss caused by incorrect user-provided information is borne by the user.',
        goodsTitle: 'Products and Pricing',
        goodsText:
          'We strive to keep product information accurate. Minor differences may occur due to lighting and display variations. Prices may be adjusted for operations and campaigns.',
        liabilityTitle: 'Limitation of Liability',
        liabilityText:
          'To the extent permitted by law, we provide reasonable assistance for service interruption or losses caused by force majeure, third-party logistics delays, or network failures, but we do not assume liabilities beyond legal requirements.',
        intellectualTitle: 'Intellectual Property',
        intellectualText:
          'All content on this platform, including text, images, logos, and page designs, is protected by applicable intellectual property laws. Unauthorized copying, distribution, or commercial use is prohibited.',
        disputeTitle: 'Dispute Resolution',
        disputeItem1:
          'If any dispute occurs, both parties should first attempt to resolve it through friendly negotiation.',
        disputeItem2:
          'If negotiation fails, either party may seek legal remedies through the competent court or authority.',
        disputeItem3:
          'The interpretation and application of these terms are subject to applicable laws and regulations.',
      },
    },
    request: {
      failed: 'Request failed',
      unauthorized: 'Session expired. Please sign in again.',
      forbidden: 'Access denied',
      notFound: 'Resource not found',
      serverError: 'Server error',
      network: 'Network error. Check your connection.',
    },
  },
  zh: {
    appTitle: 'Furniture Store',
    layout: {
      welcome: '欢迎，{name}',
      loginRegister: '登录/注册',
      profile: '个人信息',
      logout: '退出登录',
    },
    lang: {
      en: 'English',
      zh: '中文',
      label: '语言',
    },
    login: {
      tabLogin: '登录',
      tabRegister: '注册',
      email: '邮箱',
      emailRequired: '请输入邮箱',
      emailInvalid: '邮箱格式不正确',
      password: '密码',
      passwordRequired: '请输入密码',
      passwordMin: '密码至少6个字符',
      nickname: '昵称',
      nameRequired: '请输入昵称',
      nameMin: '昵称至少2个字符',
      code: '验证码',
      codeRequired: '请输入验证码',
      codeLen: '验证码为6位数字与英文字母（不区分大小写）',
      refreshCode: '刷新',
      confirmPassword: '确认密码',
      confirmRequired: '请确认密码',
      passwordMismatch: '两次密码不一致',
      signIn: '登录',
      signUp: '注册',
    },
    toast: {
      loginSuccess: '登录成功！',
      registerSuccess: '注册成功！',
      codeMismatch: '验证码输入错误',
      updateSuccess: '信息更新成功',
    },
    home: {
      loading: '加载中…',
      sectionTitle: '精选家具',
      all: '全部',
      empty: '暂无商品',
      noImage: '暂无图片',
    },
    category: buildCategoryZh(),
    product: {
      backHome: '返回首页',
      loading: '加载中…',
      loadError: '获取商品详情失败',
      specs: '商品配置',
      choosePayment: '选择支付方式',
      payNow: '立即支付',
      alipayTitle: '支付宝支付',
      wechatTitle: '微信支付',
      amount: '支付金额：',
      scanTip: '请使用{method}扫描二维码完成支付',
      orderNo: '订单号：',
      loginToPay: '请先登录后再进行支付',
      qrAlt: '二维码',
    },
    payment: {
      alipay: '支付宝',
      wechat: '微信支付',
    },
    profile: {
      title: '个人信息',
      backHome: '返回首页',
      username: '用户名',
      nickname: '昵称',
      nameRequired: '请输入昵称',
      namePlaceholder: '请输入昵称',
      newPassword: '新密码',
      passwordMin: '密码至少6位',
      passwordPlaceholderLeaveBlank: '留空则不修改密码',
      confirmPassword: '确认密码',
      confirmPlaceholder: '请再次输入新密码',
      save: '保存修改',
    },
    footer: {
      title: '运营方',
      companyName: 'FLASH AGENCY LIMITED',
      address: '香港湾仔轩尼诗道253-261号\n依时商业大厦10楼1002室',
      emailLabel: '邮箱',
      phoneLabel: '电话',
      aboutUs: '关于我们',
      refundPolicy: '退款政策',
      privacyPolicy: '隐私政策',
      termsAndConditions: '条款和条件',
    },
    legal: {
      contact: {
        title: '联系方式',
      },
      about: {
        title: '关于我们',
        subtitle: '专注家具与椅子的一站式线上选购平台',
        positionTitle: '我们的定位',
        positionText:
          '我们是一家专注于家具、餐椅、办公椅、休闲椅及相关家居产品的电商平台，致力于为用户提供设计感与实用性兼具的家具解决方案。',
        offerTitle: '我们提供什么',
        offerItem1: '精选多种风格的家具与椅子产品；',
        offerItem2: '清晰的商品参数、材质说明、尺寸信息与实拍展示；',
        offerItem3: '安全的下单流程与稳定的售后支持服务。',
        visionTitle: '我们的服务理念',
        visionText:
          '我们重视每一位用户的购物体验，从浏览、下单到售后处理，始终坚持透明、诚信、及时沟通的原则，帮助你更轻松地选到合适的家具和椅子。',
        qualityTitle: '质量与商品标准',
        qualityItem1: '大部分家具与椅子商品在发货前会进行外观与结构基础检查；',
        qualityItem2: '我们会尽量提供材质说明，包含木材、布艺、皮革或金属等信息；',
        qualityItem3: '批量生产商品在合理范围内可能存在轻微色差或纹理差异。',
        deliveryTitle: '配送与客户支持',
        deliveryText:
          '我们提供订单跟踪协助与售后咨询服务。如遇物流延误、外包装破损或配件缺失，请及时联系平台，我们会尽快协助处理。',
      },
      refund: {
        title: '退款政策',
        subtitle: '适用于本平台家具与椅子类商品订单',
        timelineTitle: '退款申请时效',
        timelineText:
          '如需申请退款，请在下单后尽快联系我们。未发货订单可优先处理取消与退款；已发货订单需根据物流状态和商品签收情况进行审核。',
        availableTitle: '可退款场景',
        availableItem1: '平台原因导致无法发货或超时未履约；',
        availableItem2: '商品存在明显质量问题且经审核属实；',
        availableItem3: '收到商品与订单描述严重不符。',
        unavailableTitle: '不支持退款场景',
        unavailableItem1: '用户主观偏好变化且商品已正常签收使用；',
        unavailableItem2: '商品因人为损坏、安装不当或保管不当造成问题；',
        unavailableItem3: '超过售后申请时效且无法提供有效订单凭证。',
        arrivalTitle: '退款到账说明',
        arrivalText:
          '审核通过后，退款将原路返回至支付账户。到账时间受支付渠道与银行处理周期影响，一般在 3-10 个工作日内完成。',
        processTitle: '退款处理流程',
        processItem1: '提交申请时请提供订单号、问题描述及相关照片/视频凭证；',
        processItem2: '客服团队会在审核过程中与您确认细节，必要时补充材料；',
        processItem3: '审核通过后系统发起退款，并同步通知处理进度。',
        shippingTitle: '退货运费与费用说明',
        shippingText:
          '如因商品质量问题或平台责任产生退货，运费可根据审核结果由平台承担；非质量原因退货，相关运费及可能产生的处理费用由买家承担。',
      },
      privacy: {
        title: '隐私政策',
        subtitle: '我们如何收集、使用和保护你的信息',
        collectTitle: '信息收集范围',
        collectText:
          '在你注册、下单、联系客服或使用站点功能时，我们可能收集必要信息，包括但不限于账号信息、订单信息、收货信息和设备访问日志。',
        usageTitle: '信息使用目的',
        usageItem1: '用于处理家具与椅子订单、发货及售后服务；',
        usageItem2: '用于账户安全验证、风险识别与平台运营优化；',
        usageItem3: '用于在你授权范围内提供活动通知与客户支持。',
        protectTitle: '信息保护措施',
        protectText:
          '我们采取合理的技术和管理措施保护你的信息安全，防止未经授权的访问、泄露、篡改或丢失。仅在实现服务所需范围内授权员工访问相关数据。',
        rightsTitle: '用户权利',
        rightsText:
          '你有权查询、更正或删除你的个人信息，也可随时联系我们申请注销账户。在法律法规要求范围内，我们会及时处理你的请求。',
        cookiesTitle: 'Cookies 与同类技术',
        cookiesText:
          '我们可能使用 Cookies 或类似技术来记住你的偏好、维持登录状态并优化站点性能。你可通过浏览器设置管理或清除 Cookies。',
        thirdPartyTitle: '第三方服务说明',
        thirdPartyItem1: '部分支付、物流、统计分析或通知服务可能由第三方提供；',
        thirdPartyItem2: '我们会要求合作方在合法、必要范围内处理相关数据；',
        thirdPartyItem3: '如涉及第三方服务，也建议你查阅其对应的隐私条款。',
      },
      terms: {
        title: '条款和条件',
        subtitle: '使用本平台前请仔细阅读以下条款',
        serviceTitle: '服务说明',
        serviceText:
          '本平台为家具与椅子商品展示和在线购买服务平台。你在使用本平台服务时，代表你已阅读并同意遵守本条款及相关政策内容。',
        accountTitle: '账户与订单',
        accountItem1: '用户应确保注册信息真实、完整并及时更新；',
        accountItem2: '订单提交后请在页面确认商品型号、数量、价格与地址；',
        accountItem3: '因用户信息填写错误造成的延误或损失由用户自行承担。',
        goodsTitle: '商品与价格',
        goodsText:
          '我们将尽力保证商品信息准确，但因拍摄光线、显示器差异等原因，实物与图片可能存在轻微差异。平台有权在活动或运营需要时调整价格。',
        liabilityTitle: '责任限制',
        liabilityText:
          '在法律允许范围内，对于不可抗力、第三方物流延误、网络故障等导致的服务中断或损失，我们将在合理范围内协助处理，但不承担超出法定范围的责任。',
        intellectualTitle: '知识产权',
        intellectualText:
          '平台内的文字、图片、标识、页面设计等内容受相关知识产权法律保护。未经许可，不得复制、传播或用于商业用途。',
        disputeTitle: '争议解决',
        disputeItem1: '若发生争议，双方应先通过友好协商方式解决；',
        disputeItem2: '协商不成时，任一方可向有管辖权的法院或机构寻求法律救济；',
        disputeItem3: '本条款的解释与适用遵循相关适用法律法规。',
      },
    },
    request: {
      failed: '请求失败',
      unauthorized: '未授权，请重新登录',
      forbidden: '拒绝访问',
      notFound: '请求的资源不存在',
      serverError: '服务器错误',
      network: '网络错误，请检查网络连接',
    },
  },
};

const STORAGE_KEY = 'app_locale';
export const DEFAULT_LOCALE = 'en';
export const SUPPORTED_LOCALES = ['en', 'zh'];

export function getStoredLocale() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'zh' || v === 'en') return v;
  } catch (_) {}
  return DEFAULT_LOCALE;
}

export function setStoredLocale(locale) {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch (_) {}
}

function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((o, k) => (o == null ? undefined : o[k]), obj);
}

export function translate(locale, path, vars) {
  const primary = getByPath(messages[locale], path);
  const fallback = getByPath(messages.en, path);
  let str = primary ?? fallback ?? path;
  if (vars && typeof str === 'string') {
    Object.entries(vars).forEach(([k, v]) => {
      str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    });
  }
  return str;
}

export function translateCategory(locale, category) {
  const table = messages[locale]?.category || messages.en.category;
  return table?.[category] ?? category;
}

export function translateRequest(locale, path) {
  return translate(locale, `request.${path}`);
}
